(function ManagerCollectionItemFilterForm($, HE)
{
	"use strict";

	var form = {
		name: 'CollectionItemFilter',
	};

	$(document).ready(function documentReady()
	{
		HE.Form.registerForm(form);

		$("#collectionitemfilter-hotel_name").on("keyup", function nameFilter() {
			var value = $(this).val().toLowerCase();

			$(".table-row").filter(function toggleName() {
				return $(this).toggle($(this).find('p:eq(0)').text().toLowerCase().indexOf(value) > -1);
			});
		});

		$("#collectionitemfilter-city").on("keyup", function cityFilter() {
			var value = $(this).val().toLowerCase();

			$(".table-row").filter(function toggleCity() {
				return $(this).toggle($(this).find('p:eq(1)').text().toLowerCase().indexOf(value) > -1);
			});
		});


		$("#collectionitemfilter-state_prov").on("keyup", function stateFilter() {
			var value = $(this).val().toLowerCase();

			$(".table-row").filter(function toggleState() {
				return $(this).toggle($(this).find('p:eq(2)').text().toLowerCase().indexOf(value) > -1);

			});
		});

		$("#collectionitemfilter-collection").on("change", function collectionFilter() {
			var value = $(this).val().toLowerCase();

			if (value === 'all') {
				value = '';
			}

			$(".table-row").filter(function toggleCollection() {
				return $(this).toggle($(this).find('p:eq(3)').text().toLowerCase().indexOf(value) > -1);

			});
		});

	});
}(jQuery, window.HE || {}));